import { InstallmentGeneratorTable as AntdInstallmentGeneratorTable } from "@empglabs/backoffice-ui-kit"

const InstallmentGeneratorTable = props => {
  return <AntdInstallmentGeneratorTable {...props} />
}

export default InstallmentGeneratorTable
